module.exports = __webpack_public_path__ + "img/lianjieshixioa.1ba756a2.png";